module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANFJREFUeNrE1bERgzAMBVDiY4CMQpMiJZuQyeJNXKagYZSMgOEkLgYiJFsINXDm8LM5/FVXBtX2n3e8NNNteDy/05gzQjuAA447IxSrgbHqZoj+lncXoOd8agbq4w/2clegqjuWoGqwFN3AcYK7BZrAgAY8Z2eiC4wopEvHwUvQGV6hWCReiuKO1yiJa6AID8TzBNdCl6zmTIgL0UCTJsHJVy00OU7wordANwGSgWehu5EpwLPRv1nNwItQskkQeDF62J12cBVU1IEkzYNTowADAJW6ilV7+kWxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_checkmark_reseller.png
// module id = 141
// module chunks = 0